// extracted by mini-css-extract-plugin
module.exports = {"introduccioData":"IntroduccioData_introduccioData__H7275"};